import React, {Component} from 'react';
import PropTypes from 'prop-types'

class SenderList extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    onDeleteClick(ev, sender){
        if (this.props.onRemoveSender !== undefined){
            this.props.onRemoveSender(sender)
        }
    }

    onExportClick(ev){
        if (this.props.onExportClick !== undefined){
            this.props.onExportClick()
        }
    }

    onChangeTipo(ev, sender){
        if (this.props.onChangeTipo !== undefined){
            this.props.onChangeTipo(sender)
        }
    }

    descrizioneTipo(tipo){
        if (tipo === 'S'){
            return "Invio diretto"
        }
        else
        {
            return "Per conoscenza"
        }
    }



    render() {
        return (
            <table className="ui table">
                <thead>
                <tr>
                    <th colSpan="3">Elenco destinatari:</th>
                </tr>
                </thead>
                <tbody>

                {this.props.senderList.map((sender)=>(
                    <tr key={sender.soggetto.idSoggetto}>
                        <td>
                            <h4 className="ui image header">
                                    <div className="content">
                                        {sender.soggetto.nomeCompleto}
                                        <div className="sub header">
                                            {sender.soggetto.indirizzo}
                                            {sender.soggetto.cap} {sender.soggetto.citta} {sender.soggetto.provincia}
                                        </div>
                                        <div className="sub header">
                                            {sender.soggetto.idDipartimento !== undefined ? sender.soggetto.idDipartimento.idOrganizzazione.nome:''}
                                            {sender.soggetto.idDipartimento !== undefined ? sender.soggetto.idDipartimento.nome : ''}
                                        </div>
                                    </div>
                            </h4></td>
                        <td className="collapsing center aligned">
                            <label onClick={(ev)=>(this.onChangeTipo(ev, sender))}
                                   className={sender.tipo ==='S' ? "ui green circular label button image": "ui orange circular label button image"}
                            >
                                {this.descrizioneTipo(sender.tipo)}
                            </label>
                        </td>
                        <td className="collapsing center aligned">
                            <a className="ui icon button red" onClick={(ev) => (this.onDeleteClick(ev, sender))}>
                                <i className="ui  icon trash"></i></a>
                        </td>
                    </tr>
                    ))}

                </tbody>
                <tfoot>
                <tr>
                    <td colSpan="3">
                        <a href="#" onClick={(ev) => (this.onExportClick(ev))}>
                            <div className="ui left floated small primary labeled icon button">
                                <i className="file excel outline icon"></i> Esporta in CSV
                            </div>
                        </a>
                    </td>
                </tr>
                </tfoot>
            </table>

            )
    }
}

SenderList.PropTypes = {
    senderList: PropTypes.array,
    onRemoveSender: PropTypes.func,
    onExportClick: PropTypes.func,
    onChangeTipo: PropTypes.func,
}

export default SenderList;



/** WEBPACK FOOTER **
 ** ./src/components/rubrica/SenderList.js
 **/